import React, {useState} from 'react';
import {gql} from '@apollo/client';
import {EzManageNavSupportModalConstants} from '@src/__generated__/EzManageNavSupportModalConstants';
import {EzManageNavSupportModalCatererAccount} from '@src/__generated__/EzManageNavSupportModalCatererAccount';
import FCWithQuery from '@src/util/FCWithQuery';
import SupportOptionsModal from './SupportOptionsModal';
import EmailModal from './EmailModal';

type ModalViews = 'options' | 'email';

interface SupportModalProps {
  catererAccount: EzManageNavSupportModalCatererAccount | null;
  constants: EzManageNavSupportModalConstants | null;
  dismissModal: () => void;
  liveChatEnabled: boolean;
  open: boolean;
  openChat: () => void;
}

const SupportModal: FCWithQuery<SupportModalProps> = {
  Component: ({catererAccount, constants, dismissModal, liveChatEnabled, open, openChat}) => {
    const [modalView, setModalView] = useState<ModalViews>('options');

    if (!open) return null;

    const handleDismissModal = () => {
      setModalView('options');
      dismissModal();
    };

    return (
      <React.Fragment>
        {modalView === 'options' && (
          <SupportOptionsModal.Component
            constants={constants}
            dismissModal={handleDismissModal}
            liveChatEnabled={liveChatEnabled}
            openChat={openChat}
            switchToEmailModal={() => setModalView('email')}
          />
        )}
        {modalView === 'email' && (
          <EmailModal.Component
            catererAccount={catererAccount}
            onDismiss={handleDismissModal}
            switchToSupportModal={() => setModalView('options')}
          />
        )}
      </React.Fragment>
    );
  },
  fragment: gql`
    fragment EzManageNavSupportModalConstants on Constants {
      ...EzManageNavSupportOptionsConstants
    }

    fragment EzManageNavSupportModalCatererAccount on CatererAccount {
      id
      ...EzManageNavEmailModalCatererAccount
    }

    ${SupportOptionsModal.fragment}
    ${EmailModal.fragment}
  `,
};

export default SupportModal;
